module.exports = __webpack_public_path__ + "img/keynote_3.715c11bf.png";